import { Material } from '../types';
import { apiRequest } from './api-client';

export interface CreateMaterialParams {
  code: string;
  name: string;
  density: number;
  pricePerKg: number;
  active: boolean;
  availableThicknesses: number[];
  dimensionLimits?: string;
}

export interface UpdateMaterialParams extends CreateMaterialParams {
  id: string;
}

export async function fetchMaterials(accessToken: string): Promise<Material[]> {
  const params = new URLSearchParams({
    includeInactive: 'true',
    includeDeleted: 'true',
    page: '1',
    pageSize: '100'
  });

  // The endpoint may return either a plain array or a paginated object { items: [...] }
  const data = await apiRequest<Material[] | { items: Material[] }>(
    `/backoffice/materials?${params.toString()}`,
    accessToken
  );
  return Array.isArray(data) ? data : (data as { items: Material[] })?.items ?? [];
}

export async function createMaterial(params: CreateMaterialParams, accessToken: string): Promise<void> {
  const { active, ...rest } = params;
  const body = {
    ...rest,
    isActive: active
  };

  await apiRequest('/backoffice/materials', accessToken, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateMaterial(params: UpdateMaterialParams, accessToken: string): Promise<void> {
  const { id, active, ...rest } = params;
  const body = {
    ...rest,
    isActive: active
  };

  await apiRequest(`/backoffice/materials/${id}`, accessToken, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export async function deleteMaterial(id: string, accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/materials/${id}`, accessToken, { method: 'DELETE' });
}

export async function restoreMaterial(id: string, accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/materials/${id}/restore`, accessToken, { method: 'POST' });
}

export async function toggleMaterialStatus(id: string, accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/materials/${id}/status`, accessToken, { method: 'PATCH' });
}
